import { landing } from '../../content/landing';
import { Badge } from '../ui';

/**
 * Khối giá, dùng chung cho trang chủ và trang Features.
 *
 * Một component thay vì chép JSX hai lần: nội dung về tiền là thứ tuyệt đối không
 * được lệch giữa hai trang — người đọc thấy "free" ở trang này và một câu khác ở
 * trang kia sẽ tin vào câu có lợi cho họ, rồi phần còn lại là tranh cãi.
 */
export function PricingNote(): React.JSX.Element {
  return (
    <section className="rounded-xl border border-border bg-surface p-6 shadow-sm">
      <div className="flex flex-wrap items-center gap-2">
        <h2 className="text-lg font-semibold">{landing.pricing.title}</h2>
        <Badge tone="good">{landing.pricing.badge}</Badge>
      </div>
      <div className="mt-3 space-y-2.5 text-sm leading-relaxed text-fg-muted">
        {landing.pricing.body.map((paragraph) => (
          <p key={paragraph.slice(0, 32)}>{paragraph}</p>
        ))}
      </div>
    </section>
  );
}
